import { AxiosRequestConfig } from 'axios';
import { apiClient } from './client';

export const withAuthorizationHeader = (
  token: string,
  config: AxiosRequestConfig = {},
): AxiosRequestConfig => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${token}`,
  },
});

export const withMultipartAuthorizationHeader = (
  token: string,
  opts: AxiosRequestConfig = {},
) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
    ...opts,
  };
};

export interface LoginResponse {
  token: string;
  userType: 'MARKET' | 'COOPERATIVE' | 'ADMIN';
  entityId: string;
  // add other fields if needed
}

export const login = async (
  email: string,
  password: string,
): Promise<LoginResponse> => {
  const response = await apiClient.post('/v1/login', { email, password });
  return response.data;
};
